import React from 'react';
import { asBlock } from '../../_lib/BlockFetcher';
import { BlockType } from '../../types/api/ElementType';
import { ContentList, ContentListItem } from '../../_lib/components/ContentList';
import { ISonURL } from '../../types/IUrl';
import { murmurhash } from '../../lib/js/hash';
import { ContentHeadline } from '../../_lib/components/ContentHeadline';
import { AttributeGroupRules } from '../../_lib/components/AttributeGroupRules/AttributeGroupRules';

type AttributeGroupListItem = AttributeGroupRules & {
  link: ISonURL;
};

type AttributeGroupsList = {
  groups: AttributeGroupListItem[];
};

/**
 * List Of Attribute Groups and their configured rules in Portal settings.
 */
function AttributeGroupsList({ groups }: AttributeGroupsList) {
  return (
    <ContentList ordered>
      {groups.map(group => (
        <ContentListItem key={group.link.name}>
          <ContentHeadline
            title={group.link.name}
            url={group.link.url}
            hierarchy={2}
            modifier="top-headline"
            headingId={`role-list-heading-${murmurhash(group.link.url)}`}
          />
          <AttributeGroupRules rules={group.rules} ruleCombination={group.ruleCombination} showHeading />
        </ContentListItem>
      ))}
    </ContentList>
  );
}

export const AttributeGroupsListBlock = asBlock(AttributeGroupsList, BlockType.attributegroupslist);
